import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import QuestionsContainer from '../../Questions/components/QuestionsContainer';
import ReviewHistoryContainer from '../../ReviewHistory/components/ReviewHistoryContainer';
import { clearSelectedAssignment } from '../actions';
import {
  getIsQuestionOverview,
  getIsViewRates,
  getSelectedAssignment,
  getSelectedRate,
} from '../selectors';
import AssignemntsContainer from './Assignemnts/AssignemntsContainer';
import GroupsListContainer from './GroupsList/GroupsListContainer';
import StatusFiltersContainer from './StatusFilters/StatusFiltersContainer';

export class AssignmentsPage extends React.Component {
  componentWillUnmount() {
    this.props.clearSelectedAssignment();
  }

  getQuestionComponent = () => {
    if (
      this.props.isQuestionOverview &&
      this.props.selectedAssignment.status === 'Submitted'
    ) {
      return (
        <ReviewHistoryContainer
          assignment={this.props.selectedAssignment}
          isQual={!this.props.isViewRates}
        />
      );
    }
    const reference = this.props.selectedAssignment?.chapter?.reference ?? {};
    return (
      <QuestionsContainer
        assignment={this.props.selectedAssignment}
        selectedRate={this.props.selectedRate.id}
        isQual={!this.props.isViewRates}
        reference={reference}
      />
    );
  };

  render() {
    return (
      <div style={{ height: '100%' }}>
        {this.props.selectedAssignment ? (
          this.getQuestionComponent()
        ) : (
          <Row style={{ height: '100%' }}>
            <GroupsListContainer />
            <Col
              md={9}
              style={{
                flex: 1,
                paddingRight: 0,
                paddingLeft: 0,
                height: '90%',
                overflow: 'auto',
              }}
            >
              <StatusFiltersContainer />
              <AssignemntsContainer />
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedAssignment: getSelectedAssignment(state),
  isQuestionOverview: getIsQuestionOverview(state),
  selectedRate: getSelectedRate(state),
  isViewRates: getIsViewRates(state),
});

const mapDispatchToProps = (dispatch) => ({
  clearSelectedAssignment: () => {
    dispatch(clearSelectedAssignment());
  },
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AssignmentsPage),
);
